const toRating = (number) => (number ? parseFloat(number).toFixed(1) : null);

export default toRating;
